/**
 * @desc 我的审批
 */

import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BasesController } from '../bases';

@BindAll()
export class ExamineController<T = any> extends BasesController<T> {
  constructor() {
    super();
  }
  async getCategoryList() {
    return await AjaxBasics.request(EnumAPI.bffsvr_examine);
  }
}
